import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Vietnamese
import viCommon from './vi/common.json';
import viAuth from './vi/auth.json';
import viOnboarding from './vi/onboarding.json';
import viChat from './vi/chat.json';
import viInvoices from './vi/invoices.json';
import viClients from './vi/clients.json';
import viSettings from './vi/settings.json';
import viBookkeeping from './vi/bookkeeping.json';
import viPayments from './vi/payments.json';
import viBilling from './vi/billing.json';
import viStudents from './vi/students.json';
import viScheduling from './vi/scheduling.json';
import viInvoicing from './vi/invoicing.json';
import viWorkbench from './vi/workbench.json';
import viCopilot from './vi/copilot.json';
import viStudentImport from './vi/studentImport.json';
import viPayroll from './vi/payroll.json';
import viProgress from './vi/progress.json';

// English
import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enOnboarding from './en/onboarding.json';
import enChat from './en/chat.json';
import enInvoices from './en/invoices.json';
import enClients from './en/clients.json';
import enSettings from './en/settings.json';
import enBookkeeping from './en/bookkeeping.json';
import enPayments from './en/payments.json';
import enBilling from './en/billing.json';
import enStudents from './en/students.json';
import enScheduling from './en/scheduling.json';
import enInvoicing from './en/invoicing.json';
import enWorkbench from './en/workbench.json';
import enCopilot from './en/copilot.json';
import enStudentImport from './en/studentImport.json';
import enPayroll from './en/payroll.json';
import enProgress from './en/progress.json';

const LANG_KEY = 'fos_lang';
const savedLang = localStorage.getItem(LANG_KEY) || 'vi';

i18n.use(initReactI18next).init({
  resources: {
    vi: {
      common: viCommon,
      auth: viAuth,
      onboarding: viOnboarding,
      chat: viChat,
      invoices: viInvoices,
      clients: viClients,
      settings: viSettings,
      bookkeeping: viBookkeeping,
      payments: viPayments,
      billing: viBilling,
      students: viStudents,
      scheduling: viScheduling,
      invoicing: viInvoicing,
      workbench: viWorkbench,
      copilot: viCopilot,
      studentImport: viStudentImport,
      payroll: viPayroll,
      progress: viProgress,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      onboarding: enOnboarding,
      chat: enChat,
      invoices: enInvoices,
      clients: enClients,
      settings: enSettings,
      bookkeeping: enBookkeeping,
      payments: enPayments,
      billing: enBilling,
      students: enStudents,
      scheduling: enScheduling,
      invoicing: enInvoicing,
      workbench: enWorkbench,
      copilot: enCopilot,
      studentImport: enStudentImport,
      payroll: enPayroll,
      progress: enProgress,
    },
  },
  lng: savedLang,
  fallbackLng: 'vi',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

// Persist language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_KEY, lng);
});

export default i18n;
